import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '../context/AuthContext';

const LegalPage = () => {
  const { slug } = useParams();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchDoc = async () => {
      setLoading(true);
      setNotFound(false);
      try {
        const res = await api.get(`/legal/documents/${slug}`);
        setDoc(res.data);
      } catch (error) {
        if (error.response?.status === 404) {
          setNotFound(true);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchDoc();
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  if (notFound) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-4">
        <h1 className="text-2xl font-bold text-text-primary">Documento non trovato</h1>
        <p className="text-text-secondary">Il documento richiesto non esiste o non è disponibile.</p>
        <Link to="/" className="text-primary underline">Torna alla home</Link>
      </div>
    );
  }

  if (!doc) return null;

  return (
    <div className="min-h-screen bg-background py-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <Link to="/" className="text-sm text-text-secondary hover:text-primary">
            ← Torna alla home
          </Link>
        </div>

        <div className="bg-white rounded-xl border border-border p-8">
          <h1 className="font-heading text-3xl font-bold text-text-primary mb-2">
            {doc.title}
          </h1>
          <p className="text-sm text-text-secondary mb-8">
            Versione {doc.version}
            {doc.updated_at && (
              <> · Aggiornato il {new Date(doc.updated_at).toLocaleDateString('it-IT')}</>
            )}
            {!doc.updated_at && doc.created_at && (
              <> · Pubblicato il {new Date(doc.created_at).toLocaleDateString('it-IT')}</>
            )}
          </p>

          <div
            className="text-text-secondary leading-relaxed"
            style={{ whiteSpace: 'pre-wrap' }}
          >
            {doc.content}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
